"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.navigateToAccessDenied = exports.ApAccessDenied = void 0;
var React = require("react");
var ApAccessDenied_styles_1 = require("./ApAccessDenied.styles");
exports.ApAccessDenied = function (_a) {
    var _b = _a.name, name = _b === void 0 ? 'AlixPartners-CFB' : _b, url = _a.url;
    return (React.createElement(ApAccessDenied_styles_1.ScrollContainer, null,
        React.createElement(ApAccessDenied_styles_1.Wrapper, null,
            React.createElement(ApAccessDenied_styles_1.Title, null, "Sorry, It looks like you do not have access yet"),
            React.createElement(ApAccessDenied_styles_1.BodyText, null,
                "If you are the administrator see below, otherwise please contact your local administrator or IT help desk get access. Please ask them to grant you access to ",
                React.createElement("span", null, name),
                "."),
            React.createElement(ApAccessDenied_styles_1.MessageWrapper, null,
                React.createElement(ApAccessDenied_styles_1.Logo, null),
                React.createElement(ApAccessDenied_styles_1.TitleText, null, "Instructions for administrators:"),
                React.createElement(ApAccessDenied_styles_1.BodyText, null, "If you are the administrator, please click the link below to complete the single sign on process. You will need to perform this for yourself first, then you can add other users."),
                url && (React.createElement(ApAccessDenied_styles_1.Link, { href: url, target: "_blank" }, url))))));
};
// Make `name` an optional parameter for backward compatibility
exports.navigateToAccessDenied = function (url, name) {
    window.history.replaceState({ state: { aadName: name || '', aadUrl: url } }, '', '/accessdenied');
    window.location.href = '/accessdenied';
};
//# sourceMappingURL=ApAccessDenied.js.map